import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { loginUser, forgotPassword } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";

const EmailLoginForm = ({ onBack, onLoginSuccess }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await loginUser(formData);
      console.log('Login response:', data.token);
      if (data?.token) {
        // Create user object in the same format as Google login
        const userData = {
          email: data.email,
          name: data.username,
          token: data.token,
          id: data.id,
          // Add any other user data that might be needed
        };

        // Store user data in localStorage
        localStorage.setItem('accessToken', data.token);
        localStorage.setItem('user', JSON.stringify(userData)); // Store complete user object

        // Close modal and clean up
        $("#profileModal").hide();
        $(".modal-backdrop").remove();
        $('body').removeClass('modal-open');
        $('body').css('padding-right', '0px');
        $('body').css('overflow', 'auto');

        // Trigger a custom event to notify navbar of login
        window.dispatchEvent(new CustomEvent('userLogin', { detail: userData }));

        // Call the onLoginSuccess callback if provided
        if (onLoginSuccess) {
          onLoginSuccess(userData);
        } else {
          navigate('/');
        }
      } else {
        alert('Invalid credentials. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      // Show the actual API message if available, otherwise show generic error
      const errorMessage = error?.response?.data?.message || error?.message || 'Something went wrong during login.';
      alert(errorMessage);
    } finally {
      setLoading(false);
      $("#profileModal").hide();
      $(".modal-backdrop").remove();
      $('body').removeClass('modal-open');
      $('body').css('padding-right', '0px');
      $('body').css('overflow', 'auto');
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotPasswordLoading(true);

    try {
      const data = await forgotPassword({ email: forgotPasswordEmail });
      alert(`Password reset link has been sent to ${forgotPasswordEmail}`);
      setShowForgotPassword(false);
      setForgotPasswordEmail('');
    } catch (error) {
      console.error('Forgot password error:', error);
      // Show the actual API message if available, otherwise show generic error
      const errorMessage = error?.response?.data?.message || error?.message || 'Something went wrong. Please try again.';
      alert(errorMessage);
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  const handleShowForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setForgotPasswordEmail('');
  };

  return (
    <div className="email-login-form p-4">
      {!showForgotPassword ? (
        // Login Form
        <form onSubmit={handleSubmit}>
          {/* Top Row with Back Button and Title */}
          <h4 className="m-0 text-center flex-grow-1">Login with email</h4>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <button
              type="button"
              className="btn btn-link text-decoration-none"
              onClick={onBack}
            >
              ← Back
            </button>
          
            <div style={{ width: '4rem' }}></div> {/* Spacer for alignment */}
          </div>

          {/* Email Field */}
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password Field with Toggle */}
          <div className="mb-3 position-relative">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="position-relative">
                <input
              type={showPassword ? 'text' : 'password'}
              className="form-control pe-5"
              id="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span
              className="position-absolute top-50 end-0 translate-middle-y me-3"
              style={{ cursor: 'pointer' }}
              onClick={togglePasswordVisibility}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
            </div>
            
          </div>

          {/* Forgot Password */}
          <div className="text-end mb-4">
            <button 
              type="button" 
              className="btn btn-link p-0 text-decoration-none"
              onClick={handleShowForgotPassword}
            >
              Forgot Password?
            </button>
          </div>

          {/* Submit Button */}
          <div className="d-grid">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : (
                'Login'
              )}
            </button>
          </div>
        </form>
      ) : (
        // Forgot Password Form
        <form onSubmit={handleForgotPassword}>
          {/* Top Row with Back Button and Title */}
          <h4 className="m-0 text-center flex-grow-1">Reset Password</h4>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <button
              type="button"
              className="btn btn-link text-decoration-none"
              onClick={handleBackToLogin}
            >
              ← Back
            </button>
          
            <div style={{ width: '4rem' }}></div> {/* Spacer for alignment */}
          </div>

          {/* Instructions */}
          <p className="text-muted mb-4">
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {/* Email Field */}
          <div className="mb-4">
            <label htmlFor="forgotEmail" className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              id="forgotEmail"
              placeholder="Enter your email"
              value={forgotPasswordEmail}
              onChange={(e) => setForgotPasswordEmail(e.target.value)}
              required
            />
          </div>

          {/* Submit Button */}
          <div className="d-grid">
            <button type="submit" className="btn btn-primary" disabled={forgotPasswordLoading}>
              {forgotPasswordLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default EmailLoginForm;
